import React from 'react'
import { Box, Grid, Typography, useMediaQuery } from '@mui/material';
import server from '../../images/server.png';
import client from '../../images/client.png';
import ServiceItem from './ServiceItem';

function Service() {
    const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('sm'));
    const serverText = [
        "Designing and building RESTful APIs to connect frontend and backend components.",
        "Implementing authentication and authorization mechanisms for secure user access.",
        "Handling database operations using MongoDB or other databases to manage data.",
        "Utilizing middleware for request handling, data validation, and error management.",
        "Optimizing server performance and scalability to ensure smooth user experiences.",
        "Deploying applications to cloud platforms like Vercel or Render for seamless online access."
    ];

    const clientText = [
        "Creating user-friendly and visually appealing UI components using React.js.",
        "Implementing state management with tools like Redux for centralized data handling.",
        "Integrating APIs to fetch and display dynamic data on web pages.",
        "Crafting responsive designs that ensure optimal user experiences across devices.",
        "Optimizing web performance by minimizing rendering bottlenecks and enhancing loading speed.",
        "Utilizing CSS preprocessors and styling libraries to achieve consistent and visually appealing designs."
    ];

    return (
        <Box component={"div"} id='service' py={5}>
            <Typography variant='h3' sx={{ fontWeight: "700" }} textAlign="center" width={300} borderBottom="1px solid" borderColor={"primary"} color="primary" m="auto" mb={5} >Service</Typography>
            <Grid container px={isSmallScreen ? 2 : 10} gap={10} sx={{alignItems: "stretch"}}>
                <Grid item lg>
                    <ServiceItem 
                        img={server} 
                        title="Server Side Development" 
                        texts={serverText}
                    />
                </Grid>
                <Grid item lg>
                    <ServiceItem 
                        img={client} 
                        title="Client Side Development" 
                        texts={clientText}
                    />
                </Grid>
            </Grid>
        </Box>
    )
}

export default Service